__turbopack_context__.v({
  "boostedTagIcon": "styles-module__-uBr6q__boostedTagIcon",
  "boostedTagText": "styles-module__-uBr6q__boostedTagText",
  "gradientOverlay": "styles-module__-uBr6q__gradientOverlay",
  "priceContainer": "styles-module__-uBr6q__priceContainer",
  "productAttributesContainer": "styles-module__-uBr6q__productAttributesContainer",
  "soldText": "styles-module__-uBr6q__soldText",
  "translucentHoverOverlay": "styles-module__-uBr6q__translucentHoverOverlay",
});
